
//Show mobile nav
$('#header__lead--nav__toggle').click(function(){
  if( $(this).hasClass('header__lead--nav__toggle--active') ){
    $(this).removeClass('header__lead--nav__toggle--active');
    $('#nav, #master').removeClass('nav__active');
  }else {
    $(this).addClass('header__lead--nav__toggle--active');
    $('#nav, #master').addClass('nav__active');
  }
});

//Show mobile nav children
$('#nav ul li .mobile__dropdown--sub').click(function(){
  if( $(this).parent().hasClass('active') ){
    $(this).parent().removeClass('active');
  }else {
    $(this).parent().addClass('active');
  }
});



// WEBPACK FOOTER //
// ./src/js/navigationToggle.js